module.exports = __webpack_public_path__ + "img/recommend.515c0143.png";